import { Command } from "commander";
import { analyzeCommand } from "./analyze.js";
import { validateCommand } from "./validate.js";
import { researchCommand } from "./research.js";
import { renameCommand } from "./rename.js";
import { contributeCommand } from "./contribute.js";
import { reportCommand } from "./report.js";
import { syncCommand } from "./sync.js";
import { routeCommand } from "./route.js";
import { velocityCommand } from "./velocity.js";
import { projectCommand } from "./project.js";
import { setupCommand } from "./setup.js";
import { feedbackCommand } from "./feedback.js";
import { installPluginCommand } from "./install-plugin.js";

export const advancedCommand = new Command("advanced")
  .description("Advanced commands for power users")
  .addCommand(analyzeCommand)
  .addCommand(validateCommand)
  .addCommand(researchCommand)
  .addCommand(renameCommand)
  .addCommand(contributeCommand)
  .addCommand(reportCommand)
  .addCommand(syncCommand)
  .addCommand(routeCommand)
  .addCommand(velocityCommand)
  .addCommand(projectCommand)
  .addCommand(setupCommand)
  .addCommand(feedbackCommand)
  .addCommand(installPluginCommand);
